var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Manage"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("ModalChangeOrderDetail"),
      _vm._v(" "),
      _c("CustomMessageModal"),
      _vm._v(" "),
      _c("EventStaffingDetail"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EmailHistoriesManagement")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae946fdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae946fdc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manager/clientView/Manage.vue
// module id = 1956
// module chunks = 1